import React, { useContext, useRef } from 'react';
import useBetslip from '../common/useBetslip';
import { useHighlightOddChange } from './useHighlightOddChange';
import { BetslipContext } from '../data/betslip/BetslipConf';

export default function OddNoDesc(props) {
    const data = props.data;
	const betslipContext = useContext(BetslipContext);
	const isBetBuilder = props.isBetBuilder;
    const container = useRef(null);
    useHighlightOddChange(container, data.value, data.matchData.isLive);
    const [addBet, selected] = useBetslip({...data, isBetBuilder});

    if (data == null) {
        return null;
    }

    let classes = props.className;
    if (data.betData.pClass != null) {
        classes += ` ${data.betData.pClass}`;
    }
    if (data.value == null) {
        return (
            <div className={"xs_odd relative min-w-[50px] flex items-center justify-center bg-cs1 rounded-lg border border-cs7 " + classes}>
                <i className="bi-lock-fill px-2" />
            </div>
        );
    }
    const closedForBetBuilder = isBetBuilder && !betslipContext.isBetBuilderOddSelectable(data.matchData.sportRef, data.matchData.pal, data.matchData.avv, data.betData.id, data.betData.handicap, data.id);
	if(closedForBetBuilder){
    	classes += ' closedBetBuilder';
    }
	const styleCloseForBB = closedForBetBuilder? {"filter":"opacity(0.5)", "pointerEvents": "none"} : {};     
    return (
        <>
            {selected ?
                <div className={"xs_odd relative min-w-[50px] flex items-center justify-between bg-cs4 rounded-lg border border-cs7 " + classes} onClick={addBet}>
                    <div className="h-full w-full px-1 py-2 text-center font-medium text-xs text-cs1" ref={container}>{data.value}</div>
                </div>
                :
                data.highlighted ?
                    <div style={styleCloseForBB} className={"xs_odd relative min-w-[50px] flex items-center justify-between bg-cs15 rounded-lg border border-cs-15 " + classes} onClick={addBet}>
                        <div className="h-full w-full px-1 py-2 text-center font-medium text-xs text-cs10" ref={container}>{data.value}</div>
                    </div>
                    :
                    <div style={styleCloseForBB} className={"xs_odd relative min-w-[50px] flex items-center justify-between bg-cs1 rounded-lg border border-cs7 " + classes} onClick={addBet}>
                        <div className="h-full w-full px-1 py-2 text-center font-medium text-xs text-cs10" ref={container}>{data.value}</div>
                    </div>
            }
        </>
    );
}